import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api/axiosConfig';

// Section Management Item Component
const FacilityFormPage = () => {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  // 이 건물의 주인. 비우면 회사 직영이다. 건물주 계정이 무엇을 볼지는 이 값이
  // 정한다 -- 여기가 비어 있으면 그분 화면은 텅 빈다.
  const [clientId, setClientId] = useState('');
  const [clients, setClients] = useState([]);


  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  // 건물주 목록. 새 건물을 만들 때도 골라야 하므로 id 와 무관하게 부른다.
  useEffect(() => {
    let alive = true;
    api
      .get('/clients')
      .then((res) => alive && setClients(res.data || []))
      .catch((err) => console.error('Failed to load clients', err));
    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);
      try {
        if (id) {
          const facilityRes = await api.get(`/facilities/${id}`);
          setName(facilityRes.data.name ?? '');
          setAddress(facilityRes.data.address ?? '');
          setClientId(facilityRes.data.clientId ? String(facilityRes.data.clientId) : '');
        }
      } catch (err) {
        setError('데이터를 불러오는데 실패했습니다.');
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchInitialData();
  }, [id]);






  /**
   * 시설 정보만 저장한다.
   *
   * 예전에는 여기서 구역을 함께 만들고 지우고 점검표까지 붙였다. 구역을 고치는
   * 자리가 세 군데였고 그중 둘이 옛 모델로 점검표를 걸었다. 한 곳에서만 고치게
   * 한다 -- 구역은 '구역 관리' 다.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (id) {
        await api.patch(`/facilities/${id}`, {
          name,
          address,
          clientId: clientId ? Number(clientId) : null,
        });
        navigate(`/facilities/${id}`);
      } else {
        const res = await api.post('/facilities', {
          name,
          address,
          clientId: clientId ? Number(clientId) : null,
        });
        // 새 시설에는 구역이 없다. 만들자마자 넣을 수 있는 곳으로 보낸다.
        navigate(`/facilities/${res.data.id}/edit`);
      }
    } catch (err) {
      setError('저장에 실패했습니다.');
      console.error('Error saving facility:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="facility-form-page pb-5" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <style>{`
        .form-header {
          background-color: #fff;
          position: sticky;
          top: 0;
          z-index: 100;
          /* 위 여백은 .main-content 가 준다. 여기서 또 주면 다른 화면보다 벌어진다. */
          padding: 0 1rem 1rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #f1f5f9;
        }
        .back-btn {
          border: none;
          background: none;
          font-size: 1.5rem;
          color: #1e293b;
          padding: 0;
          margin-right: 1rem;
        }
        .page-title {
          font-size: 1.1rem;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
        }
        .btn-save {
          background-color: var(--primary-color); /* Primary */
          color: #fff;
          border: none;
          border-radius: 8px;
          padding: 0.5rem 1rem;
          font-weight: 600;
          font-size: 0.9rem;
        }
        .form-card {
          background: white;
          border-radius: 20px;
          padding: 1.25rem 1rem;
          box-shadow: 0 4px 20px rgba(0,0,0,0.03);
          border: 1px solid rgba(0,0,0,0.05);
        }
        .btn-save:disabled {
            opacity: 0.7;
        }
        .form-section {
          background-color: #fff;
          padding: 1.5rem;
          margin-bottom: 1rem;
        }
        .form-label {
          font-weight: 800;
          font-size: 1.1rem;
          margin-bottom: 0.5rem;
          color: #1e293b;
        }
        .form-control {
          border-radius: 12px;
          padding: 0.75rem 1rem;
          border: 1px solid #e2e8f0;
          font-size: 1rem;
        }
        .form-control:focus {
          border-color: var(--primary-color);
          box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
        }
        .helper-text {
          font-size: 0.9rem;
          color: #64748b;
          margin-top: 0.5rem;
        }
        .add-checklist-btn {
          background-color: #f1f5f9;
          color: #1e293b;
          border: none;
          border-radius: 8px;
          padding: 0.75rem 1rem;
          font-weight: 600;
          width: auto;
          display: inline-flex;
          align-items: center;
        }
        .section-item {
          background-color: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 1rem;
          margin-bottom: 0.75rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      `}</style>

      <div className="form-header">
        <div className="d-flex align-items-center">
          <button className="back-btn" onClick={() => navigate(-1)}>
            <i className="bi bi-arrow-left"></i>
          </button>
        </div>
        <button className="btn-save" onClick={handleSubmit} disabled={loading}>
          {loading ? '저장 중...' : (id ? '저장' : '등록')}
        </button>
      </div>

      <div className="container mt-0 px-0">
        {error && <div className="alert alert-danger m-3">{error}</div>}

        {/* Facility Info */}
        <div className="form-section">
          <div className="mb-4">
            <label htmlFor="name" className="form-label">시설 이름 <span className="text-danger">*</span></label>
            <div className="helper-text mb-2">시설 이름은 나중에 언제든 수정할 수 있어요.</div>
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder="예시) 8층 화장실"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          {/* 상태와 저장 코드는 있는데 입력란이 없었다. 그래서 주소가 빈 채로
              남아 있었고 채울 방법이 화면에 없었다. */}
          <div className="mb-4">
            <label htmlFor="address" className="form-label">주소</label>
            <input
              type="text"
              className="form-control"
              id="address"
              placeholder="예시) 서울 서초구 …"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>

          {/* 이 건물이 누구 것인가. 건물주 계정이 보는 범위가 여기서 정해진다 --
              비워 두면 그분 화면은 텅 빈 채로 열린다. */}
          <div className="mb-4">
            <label htmlFor="clientId" className="form-label">건물주</label>
            <div className="helper-text mb-2">
              비워 두면 직영입니다. 지정하면 그 건물주 계정이 이 건물의 점검·이슈·임차 현황을 봅니다.
            </div>
            <select
              className="form-select"
              id="clientId"
              value={clientId}
              onChange={(e) => setClientId(e.target.value)}
            >
              <option value="">직영 (건물주 없음)</option>
              {clients.map((c) => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacilityFormPage;
